module.exports = __webpack_public_path__ + "static/media/loading.9d142e5e.gif";